// extracted by mini-css-extract-plugin
export default {"rulesButton":"M1eWimkIo3G1O09KnwGo"};